module.exports = __webpack_public_path__ + "img/payments.b7b8adbe.png";